import { useQueries } from "react-query";
import { useDispatch } from "react-redux";
import { SWITCH_SLICES } from "../components/store/slices/switchSlices";
import { systemOf } from "../constants/systems";
import { readableTime } from "../helpers/helpers";
import { getScheduleForDeviceService } from "../services/schedule.service";

export const useGetScheduleQueries = (switchStatus, swtName) => {
  const dispatch = useDispatch();
  const { key, deviceType } = systemOf(swtName);

  const getScheduleQueries = useQueries(
    Object.values(switchStatus)
      .flatMap((zone, zoneIndex) =>
        Object.values(zone).map((machine, machineIndex) => ({
          queryKey: [machine.deviceMac, '-scheduleData'],
          queryFn: () => getScheduleForDeviceService(machine.deviceMac, deviceType),
          onSuccess: (data) => {
            if (data) {
              const { threshold, id } = data;
              const startDate = readableTime(data.startDate);
              const endDate = readableTime(data.endDate);
              const scheduleData = {
                location: Object.keys(switchStatus)[zoneIndex],
                machine: Object.keys(zone)[machineIndex],
                start: startDate,
                end: endDate,
                inputTemp: +threshold,
                index: 0,
                id,
              }
              dispatch(SWITCH_SLICES[key].addSchedule(scheduleData));
            }
          },
          onError: (error) => {
            console.error('get heating schedule fail:', error.message);
          },
          staleTime: Infinity
        }))
      )
  );

  return getScheduleQueries;
}